import { render, staticRenderFns } from "./LyricsAi.vue?vue&type=template&id=378a30e8"
import script from "./LyricsAi.vue?vue&type=script&lang=js"
export * from "./LyricsAi.vue?vue&type=script&lang=js"
import style0 from "./LyricsAi.vue?vue&type=style&index=0&id=378a30e8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports